// extracted by mini-css-extract-plugin
export default {"InstructionsVideo":"InstructionsVideo_InstructionsVideo__WLhjh","Media":"InstructionsVideo_Media__2YsDK","Text":"InstructionsVideo_Text__v9Qf4"};